export default "__VITE_ASSET__hyW1e6J1__"